import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { Chapter } from "../../entities/chapter";
import { SubjectClassReqModel } from "@boi/shared-models";

@Injectable()
export class ChapterRepo extends Repository<Chapter> {
    constructor(private dataSource: DataSource) {
        super(Chapter, dataSource.createEntityManager());
    }
    async getChaptersBySubject(req: SubjectClassReqModel) {
        const chapterData = await this.createQueryBuilder('c')
            .select('c.id, c.chapter ')
            .where(`c.subject = '${req.subject}' and c.class='${req.classId}'`)
        const data = await chapterData.getRawMany();
        return data;
    }
    async getChaptersBySubjectAndClass(req: SubjectClassReqModel) {
        const chapterData = await this.createQueryBuilder('c')
            .select('c.id, c.chapter')
            .where(`c.subject = '${req.subject}' and c.class='${req.classId}'`)
        const data = await chapterData.getRawMany();
        return data;
    }

}